import React from 'react';
import ClientHeader from './ClientHeader';
import ClientFooter from './ClientFooter';

/**
 * Client Portal Layout component with consistent branding
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 * @param {Object} props.userInfo - User information object
 * @param {Function} props.onLogout - Logout handler function
 * @param {string} [props.className] - Additional CSS classes for main content
 * @returns {React.ReactElement} ClientLayout component
 */
const ClientLayout = ({ children, userInfo, onLogout, className = '' }) => {
  return (
    <div className="min-h-screen bg-brand-blue-600 flex flex-col">
      {/* Header */}
      <ClientHeader userInfo={userInfo} onLogout={onLogout} />
      
      {/* Main Content */}
      <main className={`flex-1 ${className}`}>
        {children}
      </main>
      
      {/* Footer */}
      <ClientFooter />
    </div>
  );
};

export default ClientLayout;
